var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrop11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1:1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    ry: 3.5,
    stroke: "#1f2830"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.55 14.2-.87.9-.54-.57 1.54-1.55h.82v5.33h-.94v-4.12ZM16.03 14.4c.3 0 .56.26.56.56s-.26.56-.56.56-.56-.26-.56-.56.26-.56.56-.56Zm0 2.89c.3 0 .56.26.56.56s-.26.56-.56.56-.56-.26-.56-.56.26-.56.56-.56ZM18.55 14.2l-.87.9-.54-.57 1.54-1.55h.82v5.33h-.94v-4.12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop11);
export default __webpack_public_path__ + "static/media/crop-1-1.05f8e1fa63efc46cda3a479883427aee.svg";
export { ForwardRef as ReactComponent };